export default ['VN', 'MY', 'ID', 'SG', 'BN', 'TH'];
